import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-eye-open",
  "use": "icon-cl-eye-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-eye-open\"><path d=\"M12 3C4 3 1 11 1 11s3 8 11 8 11-8 11-8-3-8-11-8Zm0 2c5.276 0 7.945 4.267 8.809 5.996C19.944 12.713 17.255 17 12 17c-5.276 0-7.945-4.267-8.809-5.996C4.057 9.287 6.745 5 12 5Zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 .001 3.999A2 2 0 0 1 12 9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol